import { z } from "zod/v4";
import { ValidateInputPhoneNumber } from "@/app/infrastructures/misc/common-library/ValidateInputPhoneNumber";

export const receiverNameSchema = z
  .string()
  .nonempty("bookingV4.recipient.name.error.required")
  .min(3, "bookingV4.recipient.name.error.minLength");

export const receiverPhoneSchema = z
  .string()
  .nonempty("bookingV4.recipient.phone.error.required")
  .min(5, "bookingV4.recipient.phone.error.invalid")
  .refine((phone) => ValidateInputPhoneNumber(phone).success, {
    message: "bookingV4.recipient.phone.error.invalid"
  });

const receiverAddressSchema = z
  .string()
  .nonempty("bookingV4.recipient.address.error.required")
  .min(3, "bookingV4.recipient.address.error.minLength");

export const receiverSenderAddressSchema = z
  .object({
    addressReceiver: receiverAddressSchema,
    addressSender: receiverAddressSchema
  })
  .refine(
    (data) =>
      data.addressSender.trim().toLowerCase() !==
      data.addressReceiver.trim().toLowerCase(),
    {
      message: "bookingV4.recipient.address.error.sameAddress",
      path: ["addressReceiver"]
    }
  );

export const receiverCountrySchema = z
  .string()
  .nonempty("bookingV4.recipient.country.error.required");

export const receiverDistrictSchema = z
  .string()
  .nonempty("bookingV4.recipient.city.error.required");

export const receiverDistrictSchemaInternational = z
  .string()
  .nonempty("bookingV4.recipient.city.error.requiredInternational");

export const getReceiverDestinationSchema = (isDomestic: boolean) => {
  return isDomestic
    ? receiverDistrictSchema
    : receiverDistrictSchemaInternational;
};

export const receiverPostalCodeSchema = z
  .string()
  .nonempty("bookingV4.recipient.postalCode.error.required");
